var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "popup-third-form",
      attrs: { visible: _vm.showModal, size: _vm.sizeModal },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "dialog__header" }, [
          _c(
            "div",
            { staticClass: "pabsolute" },
            [
              _c("CompassIconButton", {
                attrs: { icon: "close" },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "dialog__default" },
          [
            _c(_vm.localOptions.action + "-third-form", {
              tag: "component",
              attrs: {
                current: _vm.current,
                defaultValue: _vm.value,
                options: _vm.localOptions
              },
              on: {
                close: function($event) {
                  return _vm.$emit("close")
                },
                next: _vm.next
              }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }